import React, { Component } from 'react';
import axios from "axios";
import { connect } from "react-redux";
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import Loading from "../components/Loading";
import { Link } from "react-router-dom";
import { MDBDataTable } from "mdbreact";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { dateFormat, getStoreType } from '../../../dynamicController';
import i18n from "i18next";
import PromotionCard from '../components/setting/PromotionCard';

const mySwal = withReactContent(Swal);

const STORETYPE = getStoreType()

class News extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toggled: false,
            loading: true,
            data: [],
        };
    };

    componentDidMount() {
        if (!this.props.admin.admin) this.props.history.push("/admin/dashboard");
        else {
            axios
                .post("/api/admin/setting/getNews", { id: this.props.admin.admin.operatorId, role: "operator" }, { headers: { "Content-Type": "application/json", "auth-token": this.props.admin.token } })
                .then(res => {
                    this.setState({
                        ...this.state,
                        data: res.data,
                        loading: false
                    });
                })
                .catch(err => {
                    this.setState({
                        ...this.state,
                        loading: false
                    });
                    mySwal.fire(i18n.t("Error"), i18n.t(err.response.data.error), "error");
                });
        }
    }

    handleToggle = () => this.setState({ ...this.state, toggled: !this.state.toggled });

    deleteNews = id => {
        mySwal.fire({
            title: i18n.t("Confirmation"),
            text: i18n.t("Are you sure you want to delete news?"),
            icon: "question",
            showCancelButton: true,
            cancelButtonText: i18n.t("No"),
            confirmButtonText: i18n.t("Yes"),
            cancelButtonColor: "#d33"
        }).then(click => {

            if (click.isConfirmed && click.value) {
                this.setState({
                    ...this.state,
                    loading: true
                });

                axios.post('/api/admin/setting/deleteNews', { newsId: id }, { headers: { "Content-Type": "application/json", "auth-token": this.props.admin.token } })
                    .then(res => {

                        axios
                            .post("/api/admin/setting/getNews", { id: this.props.admin.admin.operatorId, role: "operator" }, { headers: { "Content-Type": "application/json", "auth-token": this.props.admin.token } })
                            .then(res => {
                                this.setState({
                                    ...this.state,
                                    data: res.data,
                                    loading: false
                                });
                                mySwal.fire(i18n.t("Success"), i18n.t("News deleted successfully"), "success");
                            })
                            .catch(err => {
                                this.setState({
                                    ...this.state,
                                    loading: false
                                });
                                mySwal.fire(i18n.t("Error"), i18n.t(err.response.data.error), "error");
                            });

                    })
                    .catch(err => {
                        this.setState({
                            ...this.state,
                            loading: false
                        });
                        mySwal.fire(i18n.t("Error"), i18n.t(err.response.data.error), "error");
                    });
            }
        });
    }

    render() {

        let tableData = {
            columns: [
                {
                    label: i18n.t("Title"),
                    field: "title",
                    sort: "asc"
                },
                {
                    label: i18n.t("Start Date"),
                    field: "start_date",
                    sort: "asc"
                },
                {
                    label: i18n.t("End Date"),
                    field: "end_date",
                    sort: "asc"
                },
                {
                    label: i18n.t("Action"),
                    field: "action"
                }
            ],
            rows: []
        };

        if (STORETYPE === "cleanpro") {
            tableData = {
                columns: [
                    {
                        label: i18n.t("Title"),
                        field: "title",
                        sort: "asc"
                    },
                    {
                        label: i18n.t("Short Description"),
                        field: "short_description",
                        sort: "asc"
                    },
                    {
                        label: i18n.t("Start Date"),
                        field: "start_date",
                        sort: "asc"
                    },
                    {
                        label: i18n.t("End Date"),
                        field: "end_date",
                        sort: "asc"
                    },
                    {
                        label: i18n.t("Inbox"),
                        field: "inbox",
                        sort: "asc"
                    },
                    {
                        label: i18n.t("Promotion Banner"),
                        field: "promotion",
                        sort: "asc"
                    },
                    {
                        label: i18n.t("Action"),
                        field: "action"
                    }
                ],
                rows: []
            };
        }

        if (this.state.data.length) {
            for (let i = 0; i < this.state.data.length; i++) {
                const dataObject = {
                    title: this.state.data[i].title,
                    start_date: this.state.data[i].start_date ? dateFormat(this.state.data[i].start_date) : "-",
                    end_date: this.state.data[i].end_date ? dateFormat(this.state.data[i].end_date) : "-",
                    short_description: this.state.data[i].short_description ? (
                        <div dangerouslySetInnerHTML={{ __html: this.state.data[i].short_description }}></div>
                    ) : "-",
                    inbox: this.state.data[i].inbox ? i18n.t("Yes") : i18n.t("No"),
                    promotion: this.state.data[i].promotion ? i18n.t("Yes") : i18n.t("No"),
                    action: (
                        <div>
                            <i className="bi bi-pencil-square" onClick={() => this.props.history.push("/admin/news/edit", { newsId: this.state.data[i].id })}></i>
                            <i className="bi bi-trash3-fill ms-3" onClick={() => this.deleteNews(this.state.data[i].id)}></i>
                        </div>
                    )
                };
                tableData.rows.push(dataObject);

            }
        }

        const renderList = () => {

            if (this.state.loading) {
                return (
                    <Loading />
                );
            } else {
                if (!this.state.data.length) {
                    return (
                        <div className="text-center">
                            <h1> - {i18n.t("NO NEWS")} - </h1>
                        </div>
                    );
                } else {
                    return (
                        <MDBDataTable data={tableData} noBottomColumns striped hover responsive bordered />
                    );
                }
            }
        }

        return (
            <div className="admin-page-container">
                <Sidebar toggled={this.state.toggled} setToggled={this.handleToggle} />

                <div className="admin-page">
                    <Topbar handleToggle={this.handleToggle} />

                    <div className="admin-content">
                        {
                            STORETYPE !== "cleanpro" && STORETYPE !== "washup" && STORETYPE !== "jomcuci" ?
                                <PromotionCard
                                    id={this.props.admin.admin?.operatorId}
                                    role="operator"
                                    token={this.props.admin.token}
                                />
                                : null
                        }

                        <div className="card">
                            <div className="card-header d-flex justify-content-between">
                                <h5 className="card-title">{i18n.t("News")}</h5>

                                <Link className="btn btn-primary" to="/admin/news/add">
                                    {i18n.t("Add News")}
                                </Link>
                            </div>

                            <div className="card-body">
                                {
                                    renderList()
                                }
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        );
    };
};

const mapStateToProps = state => {
    return {
        admin: state.admin
    };
};

export default connect(mapStateToProps, null)(News);